if (!customElements.get('product-with-size')) {
  customElements.define('product-with-size', class ProductWithSize extends HTMLElement {
    constructor() {
      super();
      this.selector_wrap = document.querySelector('.size-selector-wrap');
      var that = this;
      this.querySelector('button.mini-product-atc').addEventListener('click', function(){
        const cartDrawerHeading = document.querySelector('.size-drawer-heading');
        const cartCountBubble = document.querySelector('.cart-count-bubble');
        if (cartDrawerHeading && cartCountBubble) {
          cartDrawerHeading.innerHTML = 'Shopping bag (' + cartCountBubble.innerHTML + ')';
        }
        if(that.selector_wrap) {
          that.selector_wrap.classList.add('active');
        }
        document.querySelector('.size-selector-content').innerHTML = that.querySelector('.temp-size-selector-content').innerHTML;
        var atc_but = document.querySelector('.size-selector-content .temp-size-selector__atc-button');
        var size_variants = document.querySelectorAll('.size-selector-wrap .size-selector-form__variant');
        size_variants.forEach((item, i) => {
          item.addEventListener('click', function(){
            size_variants.forEach((variant, i) => {
              variant.classList.remove('active');
            })
            item.classList.add('active');
            if(item.classList.contains('not-available')){
              atc_but.classList.add('disabled');
            }
            else {
              atc_but.classList.remove('disabled');
              atc_but.setAttribute('variant-id', item.getAttribute('variant-id'));
            }
          })
        });
        if(document.querySelector('.size-selector-content .size-selector-form__variant:not(.not-available)')){
          document.querySelector('.size-selector-content .size-selector-form__variant:not(.not-available)').click();
        }
        else {
          document.querySelector('size-selector-content .size-selector-form__variant').click();
        }
        atc_but.addEventListener('click', function(){
          if(atc_but.getAttribute('variant-id')) {
            let addData = {
              'items':[{
                'id': atc_but.getAttribute('variant-id'),
                'quantity': 1
              }]
            }
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(addData)
            })
            .then(response => {
              document.dispatchEvent(new CustomEvent('mini-cart:refresh'));
              that.selector_wrap.classList.remove('active');
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        })
      })
    }
  });
}
document.querySelector('.size-selector-header button:last-of-type').addEventListener('click', function(){
  if(document.querySelector('cart-drawer')) {
    document.querySelector('cart-drawer').classList.remove('active');
  }
  if(document.querySelector('.size-selector-wrap')) {
    document.querySelector('.size-selector-wrap').classList.remove('active');
  }
})

document.querySelector('.size-selector-header button:first-of-type').addEventListener('click', function(){
  if(document.querySelector('.size-selector-wrap')) {
    document.querySelector('.size-selector-wrap').classList.remove('active');
  }
})

document.querySelector('.size-selector-overlay').addEventListener('click', function(){
  document.dispatchEvent(new CustomEvent('mini-cart:close'));
  document.querySelector('.size-selector-wrap').classList.remove('active');
})

// Sets the focus to the mini cart size selector
document.addEventListener('DOMContentLoaded', () => {
  const miniCartSizeSelector = document.querySelector('.size-selector-wrap');
  if (!miniCartSizeSelector) return;

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class' && 
          miniCartSizeSelector.classList.contains("active")) {
        // Size selector in mini cart is open, sets the focus to product title
        document.querySelector("div.size-selector-content > div.size-selector-content__main > a")?.focus();
      }
    });
  });
  observer.observe(miniCartSizeSelector, { attributes: true });
});
